import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { CreateTaskType } from "./types";
import { RcFile } from "antd/es/upload";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadUserImageBulk = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile[] | File[];
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  image.forEach((file) => {
    formData.append("image", file);
  });
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImageBulk`, formData, config);
};

export const createTask = (
  payload: CreateTaskType
): Promise<AxiosResponse<CreateTaskType>> => {
  return axios.post(`${baseURL}createTask`, payload);
};

export const updateTaskById = (
  payload: CreateTaskType,
  taskId: string
): Promise<AxiosResponse<CreateTaskType>> => {
  return axios.patch(`${baseURL}updateTaskById/${taskId}`, payload);
};

export const changeWorkOrderStatus = (
  payload: { status: string },
  id: string
): Promise<AxiosResponse<CreateTaskType>> => {
  return axios.patch(`${baseURL}changeWorkOrderStatus/${id}`, payload);
};

export const deleteTask = (
  taskIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteTask`, { data: taskIds });
};
